import { Departure } from "@zvv-fkm/types";
import { DepartureNotification } from "@zvv-fkm/types/api";
import checkIsTicketMachine from "../../../../lib/hooks/CheckIsTicketMachine";
import { BaseRow } from "../BaseRow";
import LineCell from "../rowElements/LineCell";
import TimeCell from "../rowElements/TimeCell";

export function TimeBoundDepartureRow({
  departure,
  notifications,
  multipleDirection,
  showPlatform,
  showFootPath,
  showWheelchairAccessible,
  debugMode,
}: {
  departure: Departure;
  notifications: DepartureNotification[];
  multipleDirection: boolean;
  showPlatform: boolean;
  showFootPath: boolean;
  showWheelchairAccessible: boolean;
  debugMode: boolean;
}) {
  return (
    <BaseRow>
      <LineCell
        departure={departure}
        interval={false}
        type={departure.transportTypeIcon}
        lineName={departure.lineName}
        lineBgColor={departure.color}
        lineFgColor={departure.textColor}
        wheelchairAccessible={departure.wheelchairSymbol}
        affectedByNotification={departure.affectedByNotifications}
        notifications={notifications}
        showWheelchairAccessible={showWheelchairAccessible}
      />
      <TimeCell
        departure={departure}
        intervalDepartureRow={false}
        type={departure.transportTypeIcon}
        debugMode={debugMode}
      />
      <div className="flex">
        <span className="overflow-hidden">
          {departure.destinationStationName}
        </span>
      </div>
      {multipleDirection && (
        <div className="flex">
          <span className="overflow-hidden">
            {departure.departureStationName}
          </span>
        </div>
      )}
      {showFootPath && multipleDirection && (
        <div className="flex justify-center">
          <span>{departure.walkingDistance}′</span>
        </div>
      )}
      {showPlatform && (
        <div className="flex justify-center">
          <span>{departure.platform}</span>
        </div>
      )}
      {departure.messageText && (
        <div
          className={`col-span-full flex !pl-12 text-yellow ${checkIsTicketMachine() ? "text-rowTM" : "text-row"}`}
        >
          <span>{departure.messageText}</span>
        </div>
      )}
    </BaseRow>
  );
}
